import { render, staticRenderFns } from "./edit-merchant.vue?vue&type=template&id=62e570f1&"
import script from "./edit-merchant.vue?vue&type=script&lang=ts&"
export * from "./edit-merchant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-merchant.vue"
export default component.exports